import { createTypes, createAction } from 'lib/action'
const LOAD_SHIPPING_DASHBOARD = createTypes('loadshippingdashboard', 'load')
const LOAD_SHIPPING_DETAIL = createTypes('loadshippingdetail', 'load')
const REMOVE_LISTS = `REMOVE_LISTS`

const loadShippingDashboard = {
    request: (data, loading) =>
      createAction(LOAD_SHIPPING_DASHBOARD.REQUEST, { data, loading }),
    success: (lists, offset, group_by, check_load) =>
      createAction(LOAD_SHIPPING_DASHBOARD.SUCCESS, {
        lists,
        offset,
        group_by,
        check_load,
      }),
    failure: () => createAction(LOAD_SHIPPING_DASHBOARD.FAITLURE),
}

const loadShippingDetail = {
  request: (data, loading) =>
    createAction(LOAD_SHIPPING_DETAIL.REQUEST, { data, loading }),
  success: (lists) => createAction(LOAD_SHIPPING_DETAIL.SUCCESS, { lists }),
  failure: () => createAction(LOAD_SHIPPING_DETAIL.FAILURE),
}


function removeLists() {
    return {
        type: REMOVE_LISTS,
    }
}

export {
    LOAD_SHIPPING_DASHBOARD,
    loadShippingDashboard,
    LOAD_SHIPPING_DETAIL,
    loadShippingDetail,
    REMOVE_LISTS,
    removeLists,
}
  